import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "React, D3, and hooks 👉special livecode tonight 9:30pm",
  "description": "",
  "published": "2019-02-06T00:00:00.000Z",
  "redirect_from": ["/blog/react-d3-and-hooks-%f0%9f%91%89special-livecode-tonight-930pm/swizec/8928"],
  "categories": "Livecoding, Technical",
  "hero": "./img/techletter.app-screenshot-1549473338006.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yay hooks are here! `}{`\\`}{`o/`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/brian_d_vaughn/status/1093058342942060544"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.95964125560539%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'333\\'%20viewBox=\\'0%200%20400%20333\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M33%208c-5%202-11%2013-8%2013v1c-2%201%200%208%204%2011%206%207%2019%204%2023-4%202-4%202-12%200-15-4-5-13-8-19-6m30%2042c-2%202-3%207%200%209%206%206%2013-3%208-9-3-3-5-3-8%200m3%20105c-5%202-5%201-5%2038v35l3%202c2%202%204%202%2020%202h18v-30H92v-12h10v-7c1-13%206-17%2017-17h7v11h-4c-6%200-8%202-8%208v5h12l-1%205c0%207%200%207-6%207h-5v30h24v-38l-1-39H66m140%20120c-2%202-2%205%200%205l2%202c0%204%201%205%204%205s5-2%205-5c0-1%200-2%201-1%202%201%201-5-1-7-3-3-7-3-11%201m37-1c-4%204-1%2013%205%2013%204%200%208-4%208-7%200-7-8-11-13-6m38-1l-2%203-1%204c-2%202%203%207%207%207l4-2c2-1%202-2%201-3h-2l-1%203-1-2c0-2%201-3%202-3l2-1v-2c1-4-5-6-9-4m21%201h-1c-2-3-4%200-4%206%201%207%204%209%209%206%204-2%204-10%201-12s-5-2-5%200m34-1c-2%201-4%206-4%208%201%205%208%207%2012%203%205-5-2-15-8-11m-12%202l-1%201-2%201c-1%201-2%201-3-1-2-3-3-2-2%201s0%204-1%202c-1-1-1%200-1%202s1%202%205%202%205%201%205%202c0%202%202%201%203-2%202-4%202-8-1-9-2-1-2-1-2%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/10d10d4e925a8fef86068d36fc9dea4b/ca0a1/techletter.app-screenshot-1549473338006.webp 223w", "/static/10d10d4e925a8fef86068d36fc9dea4b/75680/techletter.app-screenshot-1549473338006.webp 445w", "/static/10d10d4e925a8fef86068d36fc9dea4b/d3be9/techletter.app-screenshot-1549473338006.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/10d10d4e925a8fef86068d36fc9dea4b/e92b6/techletter.app-screenshot-1549473338006.png 223w", "/static/10d10d4e925a8fef86068d36fc9dea4b/e66bf/techletter.app-screenshot-1549473338006.png 445w", "/static/10d10d4e925a8fef86068d36fc9dea4b/e85cb/techletter.app-screenshot-1549473338006.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/10d10d4e925a8fef86068d36fc9dea4b/e85cb/techletter.app-screenshot-1549473338006.png",
                "alt": "https://twitter.com/brian_d_vaughn/status/1093058342942060544",
                "title": "https://twitter.com/brian_d_vaughn/status/1093058342942060544",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/brian_d_vaughn/status/1093058342942060544`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Long awaited big updated to the React ecosystem. Very exciting.`}</p>
    <p>{`To celebrate, we're gonna do a special livecode `}<strong parentName="p">{`tonight around 9:30pm Pacific.`}</strong>{` It's going to be recorded and an edited cleaned up version will become part of React for Data Visualization launching later this month.`}</p>
    <h3 {...{
      "id": "heres-the-plan"
    }}>{`Here's the plan`}</h3>
    <ol>
      <li parentName="ol">{`Take the big example project from React for Data Visualization (`}<a parentName="li" {...{
          "href": "https://swizec.github.io/h1b-software-salaries/#*-*-*"
        }}>{`this one`}</a>{`)`}</li>
      <li parentName="ol">{`Refactor the dataviz parts to React Hooks 🎣`}</li>
      <li parentName="ol">{`Explain why and how hooks make your life easier`}</li>
      <li parentName="ol">{`Have fun`}</li>
    </ol>
    <p>{`While I `}<em parentName="p">{`have`}</em>{` played with hooks before, this will be my first time trying to refactor this particular project. You'll get to see how it all comes together from scratch. We might even discover some completely new techniques. Exciting.`}</p>
    <p>{`For a quick primer, read these articles from last year 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/building-a-react-dataviz-with-react-hooks/swizec/8801"
      }}>{`Building a React dataviz with React hooks`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/easy-d3-blackbox-components-react-hooks/swizec/8689"
      }}>{`Building a React dataviz with React hooks`}</a></p>
    <h3 {...{
      "id": "how-to-join"
    }}>{`How to join?`}</h3>
    <p>{`Plenty of ways. You'll get another email with links around 9pm. Just in case you forget :)`}</p>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://www.youtube.com/swizecteller"
      }}>{`come watch on YouTube`}</a>{` might be best to subscribe`}</p>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://www.twitch.tv/swizec"
      }}>{`join us on Twitch`}</a></p>
    <p>{`It's going to be `}<a parentName="p" {...{
        "href": "https://facebook.com/swizecpage"
      }}>{`live on Facebook`}</a></p>
    <p>{`And also `}<a parentName="p" {...{
        "href": "https://twitter.com/swizec"
      }}>{`announced on Twitter with an embed stream`}</a>{`. But I hear those have shit quality`}</p>
    <p><strong parentName="p">{`Tonight 9:30pm Pacific. See you there ✌️`}</strong></p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      